import { MOBILE_VIEW_QUERY_PARAM } from "@config/NewsletterFormConstants";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

/**
 * A custom hook to manage the mobile web view status in a way that is safe for SSR.
 * It reads the MOBILE_VIEW_QUERY_PARAM URL search parameter,
 * and returns a boolean indicating if the mobile web view is active.
 *
 * @returns {boolean} - true if in mobile web view mode, otherwise false.
 */
export const useMobWebView = () => {
  // 1. Initialize with a safe, default value (`false`). This is used for the server render.
  const [mobwebviewBool, setMobwebviewBool] = useState(false);
  const [searchParams] = useSearchParams();

  // 2. This `useEffect` hook handles all browser-side logic. It will NOT run on the server.
  useEffect(() => {
    const mobwebviewParam = searchParams.get(MOBILE_VIEW_QUERY_PARAM);
    const isMobWebViewActive = mobwebviewParam === "true";

    // Update the component's state. This may trigger a quick re-render on the client
    // to switch from the server-rendered state to the client-rendered state.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMobwebviewBool(isMobWebViewActive);
  }, [searchParams]); // Re-run this logic if the URL's search parameters change.

  return mobwebviewBool;
};
